import {
  wasteLogsResponseSchema, type WasteLogsResponse 
} from '../types';
import {
  ApiClientError, buildUrl 
} from '@/errors';
import { authFetch } from '@/lib/api-client';

const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export interface GetWasteLogsParams {
  readonly siteId: string;
  readonly type?: string;
  readonly reason?: string;
}

export async function getWasteLogs(params: GetWasteLogsParams): Promise<WasteLogsResponse> {
  const searchParams = new URLSearchParams();
  if (params.type) searchParams.set('type', params.type);
  if (params.reason) searchParams.set('reason', params.reason);

  const url = buildUrl(API_BASE, `/v1/sites/${params.siteId}/waste`, searchParams);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch waste logs');
  }
  
  const data: unknown = await response.json();
  return wasteLogsResponseSchema.parse(data);
}
